import { CommonData } from '../common_schema'

export const gcProgressData: CommonData[] = [
  {
    name: 'GC(lifetime)',
    mean: 'Gc_lifetime_average:total.values.mean',
    std: 'Gc_lifetime_average:total.values.std',
    location: 'TiKV-Details --> GC'
  },
  {
    name: 'GC(interval)',
    mean: 'Gc_run_interval_average:total.values.mean',
    std: 'Gc_run_interval_average:total.values.std',
    location: 'TiKV-Details --> GC'
  },
  {
    name: 'GC worker CPU(average between TiKV)',
    mean: 'gc_worker_cpu_avg:total.values.mean',
    std: 'gc_worker_cpu_avg:total.values.std',
    location: 'TiKV-Details --> Thread CPU --> GC worker CPU'
  },
  {
    name: 'GC worker CPU(delta between TiKV)',
    mean: 'Gc_worker_thread_cpu_delta:total.values.mean',
    std: 'Gc_worker_thread_cpu_delta:total.values.std',
    location: 'TiKV-Details --> Thread CPU --> GC worker CPU'
  },
  {
    name: 'TiKV Auto GC Progress(average between TiKV)',
    mean: 'Gc_Progress_average:total.values.mean',
    std: 'Gc_Progress_average:total.values.std',
    location: 'TiKV-Details --> GC  --> TiKV Auto GC Progress'
  },
  {
    name: 'Coprocessor Scan next( summary for Table Scan+ Index Scan)',
    mean: 'Scan_total_versions:total.values.mean',
    std: 'Scan_total_versions:total.values.std',
    location:
      'TiKV-Details --> Coprocessor Detail --> Total Ops Details (Table Scan) and Total Ops Details (Index Scan)'
  },
  {
    name: 'Coprocessor Scan processed_keys(summary for Table Scan+ Index Scan)',
    mean: 'Scan_processed_keys:total.values.mean',
    std: 'Scan_processed_keys:total.values.std',
    location:
      'TiKV-Details --> Coprocessor Detail --> Total Ops Details (Table Scan) and Total Ops Details (Index Scan)'
  },
  {
    name: 'Coprocessor Seek tombstone count',
    mean: 'Seek_tombstone:total.values.mean',
    std: 'Seek_tombstone:total.values.std',
    location:
      'TiKV-Details --> Coprocessor Detail --> Total Ops Details (Index Scan)'
  },
  {
    name: `Impact to top level's Duration and QPS?`,
    mean: '[manual]',
    std: '[manual]',
    location: '[manual]'
  }
]
